import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

//bootstrap.js for layout
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css' //this has to be last so that custom css -eg Lato font - overrides bootstrap

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
